import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'

// pages
import App from "./pages/App"
import Admin from "./pages/Admin"
import Trade from "./pages/Trade.js"
import { SelfProfile, OtherProfile, ProfileError, getOfficialName } from "./pages/Profile"
import { createBrowserRouter, RouterProvider, redirect } from "react-router-dom"

//require("dotenv").config()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <>
    <RouterProvider router={ createBrowserRouter([
      //TODO: make all 404 pages redirect to 404.html
      {
        path: "/",
        element:  <App />
      },
      {
        path: "/admin/*",
        element: <Admin />,
        loader: ({ params }) => {
          if (params["*"] !== "") {
            return redirect("/admin")
          }
        }
      },
      {
        path: "/profile/:name/*",
        element: <OtherProfile />,
        loader: async ({ params }) => {
          if (params["*"] !== "") {
            return redirect(`/profile/${params.name}`)
          }
          
          const officialName = await getOfficialName(params.name)
          if (!officialName) {
            console.warn("User \"%s\" not found!", params.name)
            throw new Response("User Not Found")
          } else {
            //replace the user input param with the database name
            return officialName
          }
        },
        errorElement: <ProfileError />
      },
      {
        path: "/profile/*",
        element: <SelfProfile />,
        loader: async ({ params }) => {
          
        }
      },
      {
        // TODO: add param so that "/trade/[name]" makes a trade with [name] 
        path: "/trade",
        element: <Trade />
      }
    ]) }>

    </RouterProvider>
  </>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
